import React from 'react';
import { Slot } from '../deprecated/InputField/slots';
var ChoiceInputLeadingVisual = function ChoiceInputLeadingVisual(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Slot, {
    name: "LeadingVisual"
  }, children);
};
ChoiceInputLeadingVisual.displayName = "ChoiceInputLeadingVisual";
export default ChoiceInputLeadingVisual;